import { AbstractEntityMapper } from '@pf/shared-services';
import {
    EquipmentTypeCreate,
    EquipmentTypeDto,
    EquipmentTypeRead,
    EquipmentTypeSearchParams,
} from '../../entities/equipment-type.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { EquipmentTypeMetadataMap } from './equipment-type.mapping-profile';

@Injectable()
export class EquipmentTypeMapper extends AbstractEntityMapper<
    EquipmentTypeRead,
    EquipmentTypeCreate,
    EquipmentTypeDto,
    EquipmentTypeSearchParams
> {
    constructor() {
        super(
            EquipmentTypeDto,
            PlatformWmsMapper,
            EquipmentTypeMetadataMap.symbols
        );
    }
}
